/*
 * Created on Sat Aug 15 2020
 *
 * Copyright (c) 2020 One FPS
 */

import React from 'react';

import './Backdrop.css';

const Backdrop = props => <div className="backdrop" onClick={props.click} />;

export default Backdrop;
